import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'kebabCase' })
export class KebabCasePipe implements PipeTransform {
  transform(value: string): string {
    return value
      .replace(/\B([A-Z])(?=[a-z])/g, '-$1')
      .replace(/\B([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/\s+/g, '-')
      .replace(/[.,\/#!$%\^&\*;:{}=\_`~()]/g, '')
      .toLowerCase();
  }
}
